import { TransshipmentType } from "../models/transshipment";
import BaseService from "./_base.service";

const endpoint = "transshipment-types";

const TransshipmentTypeService = {
  ...BaseService<TransshipmentType>({ endpoint }),
};

export default TransshipmentTypeService;
